/**
 * Points a sprite's drawn texture at its frame's UV window. The window is material
 * state, read into the map transform at each draw, so a frame change needs no new
 * texture and no upload.
 */
import { useLayoutEffect } from 'react';
import { viewToRelease } from '../resources/textures/textureView';
import { applyUvWindow } from './uvWindow';
/**
 * `texture` is the consumer's own clone or copy, and may be the previous one while a new
 * clone uploads: that one shows the new window over its own pixels. Layout, not
 * passive: the window is set before the frame that first draws the texture. A render
 * target that no view copied is every reader's, so it keeps its own window.
 */
export function useUvWindow(texture, uvWindow) {
    useLayoutEffect(() => {
        if (texture && !isSharedTarget(texture))
            applyUvWindow(texture, uvWindow);
    }, [texture, uvWindow]);
}
function isSharedTarget(texture) {
    return texture.isRenderTargetTexture && !viewToRelease(texture);
}
//# sourceMappingURL=useUvWindow.js.map